var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"namepage"},[_c('div',{staticClass:"nametitle"},[_c('span',[_vm._v(_vm._s(_vm.deptInfo.Name))])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.deptInfo.Synopsis)}},[_vm._v(_vm._s(_vm.deptInfo.WXSynopsis))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4153e64a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-office/office-name.vue
// module id = null
// module chunks = 